import AWS from "aws-sdk";
import { v4 as uuidv4 } from "uuid";
import { handlePDFExport } from "./generatePDF";
import PDFSpecificationsData from "@/pages/Project/PDFSpecificationData";
import { jwtDecode } from "jwt-decode";
import { parsePhoneNumberFromString } from "libphonenumber-js";

import { UnitValues } from "@/utils/constants";

export async function uploadToBucket(
  attachments: any,
  folderName?: string,
  type?: string
) {
  const S3_BUCKET = "design-league-files";
  // S3 Region
  const REGION = "us-east-1";

  // S3 Credentials
  AWS.config.update({
    accessKeyId: "AKIA262BSQFUEB2CFRND",
    secretAccessKey: "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",
  });
  const s3 = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });
  // Files Parameters
  const urls = await Promise.all(
    attachments.map(async (file: any) => {
      let uniqueId = uuidv4();
      // const fileNameWithoutSpaces = file?.name
      //   ? file?.name?.replace(/\s/g, "_")
      //   : `Proposal-${Date.now()}`;
      const fileNameWithoutSpaces = file?.name
        ? file?.name?.replace(/[^a-zA-Z0-9]/g, "_")
        : `Proposal-${Date.now()}`;

      const url = folderName
        ? `${folderName}s/` + uniqueId + "_" + fileNameWithoutSpaces
        : uniqueId + "_" + fileNameWithoutSpaces;
      // const url = encodeURIComponent(uniqueId + "_" + file.name);
      let params: any = {
        Bucket: S3_BUCKET,
        Key: url,
        Body: file,
      };
      if (type === "pdf") {
        params = {
          ...params,
          ContentType: "application/pdf",
        };
      }

      // Uploading file to s3
      try {
        var upload = await s3
          .putObject(params)

          .on("httpUploadProgress", () => {
            // File uploading progress
            // console.log(
            //   "Uploading " + parseInt((evt.loaded * 100) / evt.total) + "%"
            // );
            console.log("Uploading....");
          })

          .promise();

        console.log("🚀 ~ urls ~ upload:", upload);
        return {
          url: `https://design-league-files.s3.amazonaws.com/${encodeURIComponent(
            url
          )}`,
          name: file.name,
          size: file.size,
        };
      } catch (err) {
        console.error(err);
        return undefined;
      }
    })
  );
  return urls;
}

export async function uploadSingleItemToBucket(
  file: any,
  folderName?: string,
  type?: string
) {
  const S3_BUCKET = "design-league-files";
  // S3 Region
  const REGION = "us-east-1";

  // S3 Credentials
  AWS.config.update({
    accessKeyId: "AKIA262BSQFUEB2CFRND",
    secretAccessKey: "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",
  });
  const s3 = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  // Files Parameters
  let uniqueId = uuidv4();
  const fileNameWithoutSpaces = file?.name
    ? file?.name?.replace(/\s/g, "_")
    : folderName
      ? `${folderName}-${Date.now()}`
      : `Proposal-${Date.now()}`;

  const url = folderName
    ? `${folderName}s/` + uniqueId + "_" + fileNameWithoutSpaces
    : uniqueId + "_" + fileNameWithoutSpaces;
  // const url = encodeURIComponent(uniqueId + "_" + file.name);
  let params: any = {
    Bucket: S3_BUCKET,
    Key: url,
    Body: file,
  };
  if (type === "pdf") {
    params = {
      ...params,
      ContentType: "application/pdf",
    };
  }

  // Uploading file to s3
  try {
    var upload = await s3
      .putObject(params)

      .on("httpUploadProgress", () => {
        // File uploading progress
        // console.log(
        //   "Uploading " + parseInt((evt.loaded * 100) / evt.total) + "%"
        // );
        console.log("Uploading....");
      })

      .promise();

    console.log("🚀 ~ urls ~ upload:", upload);
    return {
      url: `https://design-league-files.s3.amazonaws.com/${url}`,
      name: file.name,
      size: file.size,
    };
  } catch (err) {
    console.error(err);
    return undefined;
  }
}

export async function updateSingleItemToBucket(
  file: any,
  type: string,
  url: string
) {
  const S3_BUCKET = "design-league-files";
  // S3 Region
  const REGION = "us-east-1";

  // S3 Credentials
  AWS.config.update({
    accessKeyId: "AKIA262BSQFUEB2CFRND",
    secretAccessKey: "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",
  });
  const s3 = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });
  const path = getPathFromUrl(url);

  let params: any = {
    Bucket: S3_BUCKET,
    Key: path,
    Body: file,
  };
  if (type === "pdf") {
    params = {
      ...params,
      ContentType: "application/pdf",
    };
  }

  // Uploading file to s3
  try {
    var upload = await s3
      .putObject(params)

      .on("httpUploadProgress", () => {
        // File uploading progress
        // console.log(
        //   "Uploading " + parseInt((evt.loaded * 100) / evt.total) + "%"
        // );
        console.log("Uploading....");
      })

      .promise();

    console.log(url, "🚀 ~ urls ~ upload:");
    return {
      url: `https://design-league-files.s3.amazonaws.com/${path}`,
      name: file.name,
      size: file.size,
    };
  } catch (err) {
    console.error(err);
    return undefined;
  }
}

export async function deleteFromBucket(keys: any) {
  console.log("🚀 ~ deleteFromBucket ~ keys:", keys);
  return [];
  // const S3_BUCKET = "design-league-files";
  // // S3 Region
  // const REGION = "us-east-1";

  // // S3 Credentials
  // AWS.config.update({
  //   accessKeyId: "AKIA262BSQFUC43DE2WJ",
  //   // AKIA262BSQFUMD6LAD6E
  //   secretAccessKey: "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",
  //   // SDjM1IHOxnrkhaefzpkA38MvSpQeepZpOvk3w/ST
  // });
  // const s3 = new AWS.S3({
  //   params: { Bucket: S3_BUCKET },
  //   region: REGION,
  // });

  // const payload = keys.map((key: any) => {
  //   return { Key: new URL(key).pathname.substring(1) };
  // });
  // const params = {
  //   Bucket: S3_BUCKET,
  //   Delete: {
  //     Objects: payload,
  //     Quiet: false, // Set to true to suppress errors in case of partial deletion
  //   },
  // };

  // s3.deleteObjects(params, (err, data) => {
  //   if (err) {
  //     console.error("Error deleting objects:", err);
  //   } else {
  //     console.log("Objects deleted successfully:", data);
  //   }
  // });
}

export const handlePDFGeneration = async (
  from,
  projectData,
  createdProposal,
  body,
  data
) => {
  let primaryContact;
  if (createdProposal?.client?.contact) {
    primaryContact = createdProposal?.client?.contact?.find(
      (contact: any) => contact.isPrimary
    );
  } else {
    primaryContact = data?.client?.contact?.find(
      (contact: any) => contact.isPrimary
    );
  }
  const fileBlob =
    from == "proposal"
      ? await handlePDFExport(
          `${projectData?.shippingAddress || ""}\n${
            projectData?.shippingCity || ""
          }, ${projectData?.shippingState || ""},${
            projectData?.shippingZip || ""
          }`,
          `${projectData?.billingAddress || ""}\n${
            projectData?.billingCity || ""
          }, ${projectData?.billingState || ""},${
            projectData?.billingZip || ""
          }`,
          PDFSpecificationsData(
            createdProposal?.specifications || data?.specifications || [],
            from
          ),
          body,
          "",
          from
        )
      : from == "invoice"
        ? await handlePDFExport(
            `Bill To:\n${
              createdProposal?.client?.name || data?.client?.name || ""
            },\n${primaryContact?.phone_number || ""},\n${
              primaryContact?.email || ""
            }`,
            `Billing Address:\n ${
              createdProposal?.client?.address || data?.client?.address || ""
            }, ${
              createdProposal?.client?.city
                ? createdProposal?.client?.city + ","
                : data?.client?.city
                  ? data?.client?.city + ","
                  : ""
            } ${
              createdProposal?.client?.state
                ? createdProposal?.client?.state + ","
                : data?.client?.state
                  ? data?.client?.state + ","
                  : ""
            } ${
              createdProposal?.client?.zip
                ? createdProposal?.client?.zip
                : data?.client?.zip
                  ? data?.client?.zip
                  : ""
            }`,
            PDFSpecificationsData(
              createdProposal?.specifications || data?.specifications || [],
              from
            ),
            body,
            "",
            from
          )
        : from == "purchaseorder"
          ? await handlePDFExport(
              `Bill To:\n${
                createdProposal?.client?.name || data?.client?.name || ""
              },\n${
                primaryContact?.phone_number || ""
              },\n${primaryContact?.email || ""}`,
              `Billing Address:\n ${
                createdProposal?.client?.address || data?.client?.address || ""
              }, ${
                createdProposal?.client?.city
                  ? createdProposal?.client?.city + ","
                  : data?.client?.city
                    ? data?.client?.city + ","
                    : ""
              } ${
                createdProposal?.client?.state
                  ? createdProposal?.client?.state + ","
                  : data?.client?.state
                    ? data?.client?.state + ","
                    : ""
              } ${
                createdProposal?.client?.zip
                  ? createdProposal?.client?.zip
                  : data?.client?.zip
                    ? data?.client?.zip
                    : ""
              }`,
              PDFSpecificationsData(
                createdProposal?.specifications || data?.specifications || [],
                from
              ),
              body,
              "",
              from
            )
          : null;

  return fileBlob;
};

export const groupByVendor = (data) => {
  return data.specifications.reduce((acc, spec) => {
    const vendorId = spec.vendor._id;
    const shipTo = spec.shipTo?._id;
    const key = `${vendorId}_${shipTo}`;

    if (!acc[key]) {
      acc[key] = {
        ...data,
        specifications: [],
      };
    }
    acc[key].specifications.push({
      ...spec,
    });

    return acc;
  }, {});
};

export function minutesToHHMM(minutes: number) {
  let hours = Math.floor(minutes / 60);
  let remainingMinutes = minutes % 60;

  let formattedHours = hours.toString().padStart(2, "0");
  let formattedMinutes = remainingMinutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
}

export function getPathFromUrl(fullUrl) {
  try {
    const url = new URL(fullUrl);
    // Parse the URL
    if (url.pathname?.startsWith("/")) {
      return url.pathname?.slice(1);
    }
    return url.pathname;
    // Return the path part
  } catch (error) {
    console.error("Invalid URL:", error);
    return null; // Return null if the URL is invalid
  }
}

export function convertUnitToValue(
  cost: { value: string; unit: string },
  multiplier?: string
) {
  let result;
  if (cost.unit === "%") {
    result = (parseFloat(cost.value) / 100) * parseFloat(multiplier);
  } else if (cost.unit === "curr") {
    result = parseFloat(cost.value);
  } else {
    console.log("Invalid unit type");
    return;
  }

  return result;
}

export const floatAndRound = (value) => {
  const result = parseFloat(value) || 0;
  return Math.round(result * 100) / 100;
};

export const RemoveAlphabet = (value) => {
  value = value?.toString().replace(/[^0-9.-]/gi, "");
  if (value.split(".").length > 2) {
    value = value.split(".").slice(0, 2).join(".");
  }
  return value;
};

export const handlePreventSubmitForm = (event) => {
  if (event.key === "Enter") {
    event.preventDefault(); // Prevents form submission on Enter key press
  }
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const decodeToken = (token) => {
  try {
    return jwtDecode(token); // Decodes the token payload
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const formatObject = (value, unit) => {
  try {
    return unit === "%"
      ? `${value || 0}${UnitValues[unit || ""]}`
      : `${UnitValues[unit || ""]}${value || 0}`;
  } catch (error) {
    console.error("Invalid values:", error);
    return null;
  }
};

export const toFixedDecimal = (
  value: string | number,
  decimalPlaces: number = 2
): any => {
  // If empty value, return empty string
  if (value === "" || value === undefined || value === null) {
    return "";
  }

  // Handle decimal point input
  if (typeof value === "string") {
    // Allow single decimal point
    if (value === ".") {
      return "0.";
    }

    // If last character is decimal, keep it
    if (value.endsWith(".")) {
      return value;
    }

    // If multiple decimals, keep only first one and limit decimal places
    if (value.includes(".")) {
      const [whole, decimal] = value.split(".");
      return `${whole}.${decimal.slice(0, decimalPlaces)}`;
    }

    // If no decimal, return as is
    return value;
  }

  // Convert to number for final processing
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  // Check if it's a valid number
  if (isNaN(numValue)) {
    return "";
  }

  // Only show decimals if they exist
  return Number.isInteger(numValue)
    ? numValue
    : numValue.toFixed(decimalPlaces);
};

export function numberWithCommas(amount, focusText = false) {
  if (
    amount === "NaN" ||
    isNaN(amount) ||
    amount === "" ||
    amount === undefined ||
    !amount
  ) {
    return focusText ? "" : "0.00";
  } else {
    let strAmount = amount.toString().replace(/^0+(\d)/, "$1");
    if (!focusText) {
      // When not focused, ensure 2 decimal places
      const parts = strAmount.split(".");
      if (parts.length === 1) {
        strAmount = strAmount + ".00";
      } else if (parts[1].length === 1) {
        strAmount = strAmount + "0";
      }
    }

    return strAmount.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
}

export const formatDimension = (dimension) => {
  return !dimension?.length && !dimension?.width && !dimension?.height
    ? "_"
    : `${dimension?.width ? dimension.width + "W" : ""}${dimension?.length ? " × " + dimension.length + "D" : ""}${dimension?.height ? " × " + dimension.height + "H" : ""}`;
};

export const handlePricingFocusInput = (e) => {
  if (!e.target.value || !+RemoveAlphabet(e.target.value)) {
    return "";
  }
  return RemoveAlphabet(e.target.value);
};

export const handlePricingBlurInput = (e) => {
  if (!e.target.value || !+RemoveAlphabet(e.target.value)) {
    return "0.00";
  }
  return RemoveAlphabet(e.target.value);
};

export const currencyFormat = (number: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(number);
};

export function formatPhone(number) {
  if (!number) return "";
  const phoneNumber = parsePhoneNumberFromString(number);
  if (!phoneNumber) return number; // fallback if invalid

  return phoneNumber.formatInternational(); // returns formatted string like: +92 335 5347271
}
